<template>
    <inertia-link :href="'/'">
      <img
          class="h-20"
          src="/images/logo.png"
          alt="Company name"
      />
    </inertia-link>
</template>